import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { OptionI18nEditContainer } from "@/components/features/items/edit/option/standard/i18n/ui/existing/container";

import { useGetOptionI18nParams } from "./_hooks/use-get-option-i18n-params";

export const OptionEditPageI18n = () => {
	const { hotelID, optionID, activeLangCode, navigator } = useGetOptionI18nParams();

	return (
		<PageMeta
			title="オプションの詳細"
			url={generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.I18N, {
				hotelID,
				optionID,
				langCode: activeLangCode,
			})}
		>
			<OptionI18nEditContainer
				hotelID={hotelID}
				optionID={optionID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

OptionEditPageI18n.displayName = "OptionEditPageI18n";
